"use client";

import { useHydrated } from "@trydig/ui/hooks";
import type React from "react";
import { useEffect, useState } from "react";
import { Carousel } from "@/components/ui/Carousel";
import { ProductImage } from "../ProductImage";
import styles from "./DesktopCarousel.module.css";

export type DesktopCarouselProps = {
	desktopRestImages: {
		href: string;
	}[];
};

export const DesktopCarousel = ({
	desktopRestImages,
}: DesktopCarouselProps) => {
	const hydrated = useHydrated();
	const [desktopMainImagesWidth, setDesktopMainImagesWidth] =
		useState<number>(0);

	useEffect(() => {
		const controller = new AbortController();
		const element = document.querySelector("#desktopMainImages") as HTMLElement;
		if (!element) return;

		const updateWidth = () => {
			setDesktopMainImagesWidth(element.offsetWidth);
		};

		updateWidth();

		window.addEventListener("resize", updateWidth, {
			signal: controller.signal,
		});

		return () => {
			updateWidth();
			controller.abort();
		};
	}, []);

	if (!hydrated) return null;

	return (
		<div
			style={
				{
					display: "contents",
					"--desktopMainImagesWidth": `${desktopMainImagesWidth}px`,
				} as React.CSSProperties
			}
		>
			<Carousel
				className={styles.root}
				options={{
					hide: desktopRestImages.length <= 2,
					loop: false,
					slidesToScroll: 2,
					containScroll: "trimSnaps",
					type: "controls",
				}}
			>
				{desktopRestImages.map((media, index) => (
					<ProductImage
						className={styles.carouselImage}
						priority={index < 2}
						key={index}
						src={media.href}
					/>
				))}
			</Carousel>
		</div>
	);
};
